function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M13.132 1.316H9.618V.434A.436.436 0 0 0 9.184 0a.436.436 0 0 0-.434.434v.882h-3.5V.434A.436.436 0 0 0 4.816 0a.448.448 0 0 0-.448.434v.882H.882A.875.875 0 0 0 0 2.184v10.934c0 .49.392.882.882.882h12.25a.875.875 0 0 0 .868-.882V2.184a.872.872 0 0 0-.868-.868zm0 11.802H.882V2.184h3.486v.448a.44.44 0 0 0 .448.434.427.427 0 0 0 .434-.434v-.448h3.5v.448c0 .238.196.434.434.434a.436.436 0 0 0 .434-.434v-.448h3.514v10.934zM10.066 7h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434zm0 3.5h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434zM7.434 8.75h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434zm0-3.5h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434zm-3.5 0h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434zm0 3.5h-.868a.436.436 0 0 0-.434.434v.882c0 .238.196.434.434.434h.868a.44.44 0 0 0 .448-.434v-.882a.44.44 0 0 0-.448-.434z",
  id: "a"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#25282E"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h14v14H0z"
})));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.7cd25d81.svg";
export { ForwardRef as ReactComponent };